<p-dialog [style]="{ width: '480px' }" [breakpoints]="{ '575px': '95vw' }" [(visible)]="visibility"
  [closable]="false" [modal]="true" [draggable]="false" [dismissableMask]="true" styleClass="change-password-dialog">

  <ng-template #header>
    <div class="cp-dialog-header">
      <div class="cp-header-icon">
        <i class="fa-solid fa-lock"></i>
      </div>
      <div class="cp-header-text">
        <span class="cp-title">Change Password</span>
        <span class="cp-subtitle">Update your account password securely</span>
      </div>
      <p-button class="cp-close-btn" (click)="visibility = false" text="true" severity="secondary">
        <i class="fa-solid fa-xmark"></i>
      </p-button>
    </div>
  </ng-template>

  <form [formGroup]="changePasswordForm" class="cp-form">
    <div class="cp-field">
      <label for="oldPassword" class="cp-label">Current Password <span class="cp-required">*</span></label>
      <p-password id="oldPassword" placeholder="Enter your current password" class="w-full"
        inputStyleClass="cp-input w-full" formControlName="oldPassword" [toggleMask]="true" [feedback]="false">
      </p-password>
      @if (changePasswordForm.get('oldPassword')?.touched || isSubmitted) {
      <small class="cp-error">
        @if (changePasswordForm.get('oldPassword')?.errors?.['required']) { This field is required }
        @if (formErrors['oldPassword']) { {{formErrors['oldPassword']}} }
      </small>
      }
    </div>

    <div class="cp-divider"></div>

    <div class="cp-field">
      <label for="newPassword" class="cp-label">New Password <span class="cp-required">*</span></label>
      <p-password id="newPassword" placeholder="Enter your new password" class="w-full"
        inputStyleClass="cp-input w-full" formControlName="newPassword" [toggleMask]="true">
        <ng-template #footer>
          <div class="cp-strength-checklist">
            <span class="cp-check-item" [class.valid]="passwordChecks.lower" [class.invalid]="!passwordChecks.lower">
              <i [class]="passwordChecks.lower ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
              Lowercase letter
            </span>
            <span class="cp-check-item" [class.valid]="passwordChecks.upper" [class.invalid]="!passwordChecks.upper">
              <i [class]="passwordChecks.upper ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
              Uppercase letter
            </span>
            <span class="cp-check-item" [class.valid]="passwordChecks.digit" [class.invalid]="!passwordChecks.digit">
              <i [class]="passwordChecks.digit ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
              Number
            </span>
            <span class="cp-check-item" [class.valid]="passwordChecks.special" [class.invalid]="!passwordChecks.special">
              <i [class]="passwordChecks.special ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
              Special character
            </span>
            <span class="cp-check-item" [class.valid]="passwordChecks.length" [class.invalid]="!passwordChecks.length">
              <i [class]="passwordChecks.length ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
              At least 8 characters
            </span>
          </div>
        </ng-template>
      </p-password>
      @if (changePasswordForm.get('newPassword')?.touched || isSubmitted) {
      <small class="cp-error">
        @if (changePasswordForm.get('newPassword')?.errors?.['required']) { This field is required }
        @if (changePasswordForm.get('newPassword')?.errors?.['minlength']) { Min length is 8 characters }
        @if (changePasswordForm.get('newPassword')?.errors?.['invalidPassword']) { Invalid password }
        @if (formErrors['newPassword']) { {{formErrors['newPassword']}} }
      </small>
      }
    </div>

    <div class="cp-field">
      <label for="confirmPassword" class="cp-label">Confirm New Password <span class="cp-required">*</span></label>
      <p-password id="confirmPassword" placeholder="Re-enter your new password" class="w-full"
        inputStyleClass="cp-input w-full" formControlName="confirmPassword" [toggleMask]="true" [feedback]="false"
        (paste)="preventPaste($event)">
      </p-password>
      @if (changePasswordForm.get('newPassword')?.touched || isSubmitted) {
      <small class="cp-error">
        @if (changePasswordForm.get('confirmPassword')?.errors?.['required']) { This field is required }
        @if (changePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch']) { Passwords do not match }
      </small>
      }
    </div>
  </form>

  <ng-template #footer>
    <div class="cp-footer">
      <p-button label="Cancel" variant="text" severity="secondary" styleClass="cp-btn-cancel" (onClick)="cancel()" />
      <p-button label="Update Password" severity="primary" styleClass="cp-btn-submit" [loading]="loading"
        (click)="changepassword()" />
    </div>
  </ng-template>

</p-dialog>
